import React, { ReactNode, useState } from "react";
import PropTypes from "prop-types";
import styles from "./CartSection.module.scss";

const CartSection = ({
  sectionName,
  startsOpen = false,
  children,
  classNames,
}) => {
  const [isOpen, setIsOpen] = useState(startsOpen);
  
  return (
    <section
      className={[
        "cartSection__cartSection",
        isOpen && "cartSection__open",
        classNames && classNames.wrapper
      ].filter(i=>i).join(" ")}
    >
      { sectionName && <div className={"cartSection__sectionHeader"}>
        <small>
          <strong className={"cartSection__sectionName"}>{sectionName}</strong>
        </small>
      </div> }

      <div className={["cartSection__sectionContent", classNames && classNames.content].filter(i=>i).join(" ")}>
        {children}
      </div>
    </section>
  );
};

CartSection.propTypes = {
  classNames: PropTypes.shape({
    wrapper: PropTypes.string,
    content: PropTypes.string,
  }),
  sectionName: PropTypes.string.isRequired,
  startsOpen: PropTypes.bool,
  children: PropTypes.node,
};

export default CartSection;


// WEBPACK FOOTER //
// ./src/rifa/components/layout/cart/CartSection.jsx